import React, { Component } from 'react'
import { compose } from 'recompose'
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify'
import Table from '../../../tables/reactable/DefaultTable'
import AcceptClientAccountPopup from '../actions/AcceptEditClientAccountPopup'
import RemoveClientAccount from '../actions/RemoveClientAccount'

class ClientRequestList extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.state = {
      itemsPerPage: 10,
      search: ''
    }
    this.columns = [
      'ProductionContentOwnerName',
      'ClientForSearch',
      'FullName',
      'JobTitle',
      'Email',
      'EmailForSearch',
      'StatusModifiedDate',
	    'Actions'
    ]
    this.columnNames = [
      'Client',
      'ClientForSearch',
      'Full name',
      'Job title',
      'Email',
      'EmailForSearch',
      'Status modified date',
	    'Actions'
    ]
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  onSearch(e) {
    e.preventDefault()
    this.setState({
      search: e.target.value
    })
    return false
  }

  render() {
    let items = this.props.items.map(item => {
      return Object.assign({}, item, {
      	ProductionContentOwnerName: item.ProductionContentOwnerIconUrl ? (<img src={item.ProductionContentOwnerIconUrl} style={{width: '50px'}} alt="" />) : (null),
        ClientForSearch: item.ProductionContentOwnerName,
        Email: (<a href={'mailto:' + item.Email}>{item.Email}</a>),
        EmailForSearch: item.Email,
        StatusModifiedDate: item.StatusModifiedDateAsString,
		Actions: (
      <span>
        <AcceptClientAccountPopup accountId={item.Id} onReload={this.props.onReload} mode="activate"/>
        <RemoveClientAccount accountId={item.Id} onReload={this.props.onReload} buttonText="Reject" />
      </span>)
      })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          hiddenColumns={[
            'ClientForSearch',
            'EmailForSearch'
          ]}
          searchable={[
            'ClientForSearch',
            'FullName',
            'JobTitle',
            'EmailForSearch'
          ]}
          search={this.state.search}
          onSearch={this.onSearch}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={false}
          sortable={[
            'ProductionContentOwnerName',
            'FullName',
            'JobTitle',
            'Email',
            'StatusModifiedDate'
          ]}
          defaultSort={{column: 'FullName', direction: 'asc'}}
        />
      </div>
    )
  }
}

export default compose(WithAjax, WithNotify)(ClientRequestList)
